import { get } from 'utils/axios';
import { CollectionFirstAvailableDateResponse } from '@kouto/types';

const getFirstAvailableCollectionDate = async (url: string) => {
  const response = await get<{ data: CollectionFirstAvailableDateResponse }>(
    url,
  );
  return response.data;
};

export default getFirstAvailableCollectionDate;
